import styled from "@emotion/styled";
import Image from "next/image";
import colors from "theme/colors";
import { NewText } from "ui";
import { getUmbracoMediaUrl } from "utils/utils";

const StyledCard = styled.div<{ mediumDesktopWidth: number }>`
width: 319px;
min-height: 187px;
${(props) => props.theme.breakpoints.down("lg")} {
    width: ${(props) => props.mediumDesktopWidth}px;
    min-height: 179px;
}
${(props) => props.theme.breakpoints.down("md")} {
    width: auto;
    min-height: 209px;
}
display: flex;
flex-direction: column;
align-items: center;
justify-content: flex-start;
padding-top: 10px;
gap: 20px;
border: 1px solid #153E691A;
border-radius: 12px;
opacity: 0px;
background-color: white;
box-shadow: 0px 4px 30px 0px #0000000D;
`

const StyledCardText = styled.div`
text-align: center;
padding: 10px;
// font-size: 18px;
// font-weight: 500;
// line-height: 20px;
// text-align: center;
// width: 90%;
// span {
//     font-size: 18px;
//     font-weight: 400;
//     line-height: 20px;
//     text-align: center;
// }
// ${(props) => props.theme.breakpoints.down("md")} {
//     font-size: 16px;
// }
`
const StyledImage = styled(Image)`
`
export interface BenefitsCardChargeProps {
    icon: string,
    title: string,
    description: string,
    mediumDesktopWidth?: number
    index: number
}
function BenefitsCardCharge({ icon, description, title, mediumDesktopWidth = 290 }: BenefitsCardChargeProps) {
    return (
        <StyledCard
            mediumDesktopWidth={mediumDesktopWidth}
        >
            <StyledImage
                src={getUmbracoMediaUrl(icon)}
                width={64}
                height={74}
                alt=""
                style={{ objectFit: "contain" }}
            // priority={index <= 1}
            />
            <StyledCardText>
                <NewText
                    component={"h3"}
                    largeDesktopFontSize={18}
                    largeDesktopLineHeight="20px"
                    desktopFontSize={18}
                    desktopLineHeight={"20px"}
                    mobileFontSize={16}
                    mobileLineHeight="18px"
                    color={colors.black}
                    desktopFontWeight={500}
                >
                    {title}
                </NewText>

                <NewText
                    component={"p"}
                    largeDesktopFontSize={18}
                    largeDesktopLineHeight="20px"
                    desktopFontSize={18}
                    desktopLineHeight={"20px"}
                    mobileFontSize={16}
                    mobileLineHeight="18px"
                    color={colors.black}
                >
                    {description}
                </NewText>

            </StyledCardText>
        </StyledCard>
    );
}
export default BenefitsCardCharge;
